import logoGrandeChambaticon from './logo_blanco.png'
import logoLetrasChambaticon from "./chamba-ticon.png"
import logoGrandeMitadChambaticon from "./fondo_login_izquierdo-01.jpg"

export default {
    "logoGrandeChambaticon": logoGrandeChambaticon,
    "logoLetrasChambaticon": logoLetrasChambaticon,
    "logoGrandeMitadChambaticon": logoGrandeMitadChambaticon
}